import React, { Component } from 'react';
import { Header } from '../../../components';
import SetWelcome from './SetWelcome';

class SetWelcomePage extends Component {
  render() {
    return (
      <div className="hub-wrapperContainer">
        <div className="hub-headerContentWrapper">
          <Header />
          <div className="hub-contentWrapper">
            <SetWelcome />
          </div>
        </div>
      </div>
    );
  }
}

export default SetWelcomePage;
